import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Download } from "lucide-react";
import IgCard from "@/components/IgCard";
import { isNew } from "@/components/NewBadge";
import { catsOf } from "@/lib/catalog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const HANDLE = process.env.REACT_APP_INSTAGRAM_HANDLE || "@arishacreations";
const tag = (s) => `#${s.replace(/[^a-z0-9]/gi, "")}`;

export const captionFor = (p) => {
  const colours = (p.colors || []).map(c => c.name).join(" · ");
  return [
    `New in: ${p.name}`,
    p.description,
    `₹${Number(p.price).toLocaleString("en-IN")}${p.original_price > p.price ? ` (was ₹${Number(p.original_price).toLocaleString("en-IN")})` : ""} · Sizes ${(p.sizes || []).join(", ")}${colours ? ` · ${colours}` : ""}`,
    `Order on WhatsApp +91 9769128394 or tap the link in bio. ${HANDLE}`,
    ["#ArishaCreations", "#NewArrivals", ...catsOf(p).map(tag), "#EthnicWear", "#SuitSet", "#MumbaiFashion", "#IndianWear", "#EmbroideredSuit"].join(" "),
  ].filter(Boolean).join("\n\n");
};

export const InstagramPanel = ({ token, products }) => {
  const fresh = products.filter(isNew);
  const [connected, setConnected] = useState(false);
  const root = useRef(null);

  useEffect(() => {
    axios.get(`${API}/admin/instagram/status`, { headers: { "X-Admin-Token": token } }).then(r => setConnected(r.data.connected)).catch(() => setConnected(false));
  }, [token]);

  const downloadAll = async () => {
    const buttons = root.current?.querySelectorAll("[data-ig-download]") || [];
    for (const b of buttons) { b.click(); await new Promise(r => setTimeout(r, 600)); }
  };

  return (
    <section className="admin-section" data-testid="admin-instagram-section" ref={root}>
      <div className="admin-section-head">
        <h2 style={{ border: 0, padding: 0, margin: 0 }}>New arrivals → Instagram ({fresh.length})</h2>
        {fresh.length > 0 && <button className="primary-button" onClick={downloadAll} data-testid="ig-download-all"><Download size={13} /> Download all</button>}
      </div>
      <p className="ig-hint" data-testid="ig-connection-status">
        {connected ? "Auto-post is connected: tap “Post now” to publish straight to Instagram."
          : "On your phone, tap Share to open Instagram. The caption and hashtags are copied, so just paste. Auto-post turns on once your Instagram Business account is connected."}
      </p>
      {fresh.length === 0 ? <p className="ig-hint" data-testid="ig-empty">No pieces added in the last 30 days.</p> : (
        <div className="ig-grid">
          {fresh.map(p => <IgCard key={p.id} product={p} caption={captionFor(p)} token={token} canAutoPost={connected} />)}
        </div>
      )}
    </section>
  );
};
